'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timestampIsToday = undefined;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timestampIsToday = exports.timestampIsToday = function timestampIsToday(timestamp) {
  var today = _I18n2.default.moment(Date.now());

  return today.isSame(_I18n2.default.moment(timestamp), 'd');
};


//////////////////
// WEBPACK FOOTER
// ./js/availability/util/timestampIsToday.js
// module id = 386
// module chunks = 2 3